<jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study-editor.study-dataset.variable-batch-action.heading' | translate}}" [isCollapsed]="true">
    <ng-container>
        <div class="card card-body">
            <div class="row g-2 align-items-center">
                <div class="col-auto">
                    <label class="mb-0">{{'study-editor.study-dataset.variable-batch-action.select-variable' | translate}}:</label>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-2">
                    <ng-select [items]="variables" [(ngModel)]="selectedVariable" (change)="onVariableChange($event)"
                               bindLabel="name"
                               placeholder="{{'study-editor.study-dataset.variable-batch-action.select-variable' | translate}}">
                        <ng-template ng-label-tmp let-item="item">
                            {{ item.alias || item.name }}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            {{ item.alias || item.name }}
                        </ng-template>
                    </ng-select>
                </div>

                @if (selectedVariable) {
                    <div class="col-auto">
                        <label class="mb-0">{{ 'study-editor.study-dataset.variable-batch-action.select-batch-action' | translate }}</label>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3 col-lg-2">
                        <ng-select placeholder="{{'study-editor.study-dataset.variable-batch-action.select-action' | translate}}" [(ngModel)]="selectedBatchAction">
                            @if (isPendingView && principal.hasAnyAuthorityDirect(MANAGE_PENDING_OBSERVATION_VALUES_PERMISSIONS) ||
                            !isPendingView && principal.hasAnyAuthorityDirect(MANAGE_CONFIRMED_OBSERVATION_VALUES_PERMISSIONS)) {
                                <ng-option [value]="1">{{ 'study-editor.study-dataset.variable-batch-action.select-batch-action.1' | translate}}</ng-option>
                                <ng-option [value]="3">{{ 'study-editor.study-dataset.variable-batch-action.select-batch-action.3' | translate}}</ng-option>
                            }
                            @if (isPendingView && principal.hasAnyAuthorityDirect(MANAGE_ACCEPT_PENDING_OBSERVATION_VALUES_PERMISSIONS)) {
                                <ng-option [value]="2">{{ 'study-editor.study-dataset.variable-batch-action.select-batch-action.2' | translate}}</ng-option>
                            }
                        </ng-select>
                    </div>

                    @if (selectedBatchAction === 1) {
                        <div class="col-auto">
                            <label class="mb-0">{{ 'study-editor.study-dataset.variable-batch-action.select-batch-action.new-value' | translate }}</label>
                        </div>
                        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
                            @switch (selectedVariable.dataTypeCode) {
                                @case ('C') {
                                    @if (isBreedingMethod()) {
                                        <jhi-breeding-methods-select [selectWidth]="'100%'"
                                                                     [showAllMethodTypesOption]="false"
                                                                     [showDerivativeMethodTypesOption]="false"
                                                                     [showGenerativeMethodTypesOption]="false"
                                                                     [breedingMethodFilterTypeValue]="BreedingMethodFilterTypeEnum.DERIVATIVE_AND_MAINTENANCE_ONLY"
                                                                     [showFavoritesCheckbox]="false"
                                                                     [customClass]="'ng-select-inline-edit'"
                                                                     [appendTo]="'body'"
                                                                     (onMethodChanged)="onMethodChanged($event)">
                                        </jhi-breeding-methods-select>
                                    }

                                    @if (!isBreedingMethod() && categoricalItems && categoricalItems.length > 0) {
                                        <ng-select name="categoricalDropdown"
                                                   id="categoricalDropdown"
                                                   [items]="categoricalItems"
                                                   [(ngModel)]="value"
                                                   [bindValue]="'name'"
                                                   class="ng-select-inline-edit"
                                                   [clearable]="true"
                                                   appendTo="body"
                                                   dropdownPosition="auto"
                                                   [addTag]="true"
                                                   [addTagText]="'global.add-custom-value' | translate"
                                                   [selectOnTab]="true"
                                                   [hideSelected]="false"
                                                   [editableSearchTerm]="true"
                                                   #inputElement>
                                            <ng-template ng-label-tmp let-item="item">
                                                {{item.name}} - {{item.description}}
                                            </ng-template>
                                            <ng-template ng-option-tmp let-possibleValue="item">
                                                @if (isCategoricalDescriptionView) {
                                                    <div title="{{possibleValue.description}}">{{possibleValue.name}} - {{possibleValue.description}} </div>
                                                } @else {
                                                    <div title="{{possibleValue.name}}">{{possibleValue.name}}</div>
                                                }
                                            </ng-template>
                                        </ng-select>
                                    }

                                    @if (!isBreedingMethod() && categoricalItems && categoricalItems.length === 0) {
                                        <input type="text"
                                               class="form-control text-input"
                                               [(ngModel)]="value"
                                               #inputElement>
                                    }
                                }

                                @case ('N') {
                                    <input type="number"
                                           class="form-control number-input"
                                           [(ngModel)]="value"
                                           #inputElement>
                                }

                                @case ('T') {
                                    <input type="text"
                                           maxlength="255"
                                           class="form-control text-input"
                                           [(ngModel)]="value"
                                           #inputElement>
                                }

                                @case ('D') {
                                    <div class="d-flex">
                                        <div class="input-group">
                                            <input class="form-control date-input"
                                                   [placeholder]="'global.date.no.dash.placeholder' | translate"
                                                   [(ngModel)]="value"
                                                   [placement]="'auto'"
                                                   [container]="'body'"
                                                   [autoClose]="true"
                                                   ngbDatepicker #inputElement #datepicker="ngbDatepicker">
                                            <button class="btn btn-sm btn-outline-secondary calendar" (click)="datepicker.toggle()"
                                                    type="button"><i class="fa fa-calendar"></i></button>
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                    }
                    @if (selectedBatchAction > 0) {
                        <div class="col-auto ms-auto">
                            <button class="btn btn-info" [disabled]="selectedBatchAction === 1 && (value === null || value === undefined)" (click)="applyBatchAction()" jhiTranslate="apply">Apply</button>
                        </div>
                    }
                }
            </div>
        </div>
    </ng-container>
</jhi-collapsible>
